import React from 'react';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import RowWrapper from './RowWrapper';
var ItemRow = function (_a) {
    var rowIdx = _a.rowIdx, width = _a.width, height = _a.height, scrollOptims = _a.scrollOptims, children = _a.children;
    return (React.createElement(RowWrapper, { style: {
            width: width,
            containIntrinsicSize: "".concat(width, "px ").concat(height, "px"),
            contentVisibility: scrollOptims ? 'auto' : 'visible',
        }, "data-hook": "".concat(BiDataHook.CONTENT_ROW_IDX, "-").concat(rowIdx) }, children));
};
ItemRow.displayName = 'ItemRow';
export default ItemRow;
//# sourceMappingURL=ItemRow.js.map